import countyToZipOH from './CountyToZip.json'
import zipToLatLngOH from './ZipToLatLng.json'
import countyToZipMI from './CountyToZip.MI.json'
import zipToLatLngMI from './ZipToLatLng.MI.json'

export const DEFAULT_STATE = 'OH' as const
export const SUPPORTED_STATES = ['OH', 'MI'] as const

export type SupportedState = typeof SUPPORTED_STATES[number]
export type CountyToZipMap = Record<string, number[]>
export type RegionToCountyMap = Record<string, string[]>
export type ZipToLatLngMap = Record<string, [number, number]>

export type StateServiceAreaData = {
    countyToZip: CountyToZipMap
    regionToCounty: RegionToCountyMap
    zipToLatLng: ZipToLatLngMap
}

export type StateServiceAreaDebugSummary = {
    state: SupportedState
    countyCount: number
    regionCount: number
    uniqueCountyZipCount: number
    zipCoordinateCount: number
    missingZipCoordinateCount: number
    missingZipCoordinateSample: string[]
}

const stateServiceAreaData: Record<SupportedState, StateServiceAreaData> = {
    OH: {
        countyToZip: countyToZipOH.countyToZip,
        regionToCounty: countyToZipOH.regionToCounty,
        zipToLatLng: zipToLatLngOH as unknown as ZipToLatLngMap
    },
    MI: {
        countyToZip: countyToZipMI.countyToZip,
        regionToCounty: countyToZipMI.regionToCounty,
        zipToLatLng: zipToLatLngMI as unknown as ZipToLatLngMap
    }
}

export const normalizeState = (state?: string): SupportedState => {
    const normalized = (state || DEFAULT_STATE).toUpperCase()
    return (SUPPORTED_STATES as readonly string[]).includes(normalized) ? normalized as SupportedState : DEFAULT_STATE
}

export const getStateServiceAreaData = (state?: string): StateServiceAreaData => {
    return stateServiceAreaData[normalizeState(state)]
}

export const getStateServiceAreaDebugSummary = (state?: string): StateServiceAreaDebugSummary => {
    const normalizedState = normalizeState(state)
    const { countyToZip, regionToCounty, zipToLatLng } = getStateServiceAreaData(normalizedState)

    const uniqueCountyZips = new Set<string>()
    Object.values(countyToZip).forEach((zips) => {
        zips.forEach((zip) => {
            uniqueCountyZips.add(zip.toString().padStart(5, '0'))
        })
    })

    const missingZips = Array.from(uniqueCountyZips).filter((zip) => !(zip in zipToLatLng))

    return {
        state: normalizedState,
        countyCount: Object.keys(countyToZip).length,
        regionCount: Object.keys(regionToCounty).length,
        uniqueCountyZipCount: uniqueCountyZips.size,
        zipCoordinateCount: Object.keys(zipToLatLng).length,
        missingZipCoordinateCount: missingZips.length,
        missingZipCoordinateSample: missingZips.slice(0, 10)
    }
}
